/*
    创建者：shuxiaokai
    创建时间：2019-09-09 22:06
    模块名称：xxxx
    备注：xxxx
*/
<template>
    <div>
        bbb
    </div>
</template>

<script>
export default {
    data() {
        return {

        };
    },
    created() {

    },
    methods: {

    }
};
</script>



<style lang="scss">

</style>
